import * as React from "react";
import { observer } from "mobx-react-lite";
import { AColumn, AsyncTable } from "src/components/tables/AsyncTable";
import { ZBom2SummaryRow } from "src/businessServices/services/bsBom2/Bom2Types";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { bomSummaryColumns } from "../../../Bom2Summary";
import { BomPosCopyToStore } from "./BomPosCopyToStore";

interface PropsBomPosCopyToStep2 {
  store: BomPosCopyToStore;
}

export const BomPosCopyToStep2: React.FC<PropsBomPosCopyToStep2> = observer(
  ({ store }) => {
    const columns: AColumn<ZBom2SummaryRow>[] = React.useMemo(
      bomSummaryColumns,
      [],
    );
    const { bomsStore } = store;
    if (!bomsStore) return null;
    return (
      <AsyncTable
        store={bomsStore}
        columns={columns}
        onRowClick={(row) => selectOnRowClick(row, bomsStore)}
      />
    );
  },
);
